import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdditionalReciepientsData, getAquaaMarketGroupData, getAquaaValidateTicketNo, getEvaluationFormData, updateAquaaAcknowledgementDataStart, updateEFMissingDataStart, updateEvaluationFormDataStart } from '../../actions/Applications/aquaa.action';
import './EvaluationForm.css';
import { useLocation } from 'react-router-dom';
import Save_Image from './../../assets/images/Save_Image.PNG';
import Reset_Icon from './../../assets/images/Reset_Icon.png'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import MultipleSelectChip from '../Reusable components/MultiselectwithSearch';
import { getRolesTabUsers } from '../../actions/Onboard.action';
import { debounce } from '@material-ui/core';
import { AssignedAccountsTblPopUp } from '../../components/TeamLeaderView/AgentsKPIModels/AgentsKPIModels';
import { processScores } from './ScoreCalculations';
import { getUserData, getUserToken } from '../../actions/user.action';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { DateFormatter } from '../../components/ReusableComponents/DateFormatter';
import { OnboardSelect } from '../../components/Onboard/OnboardComponents/Dropdown/Select';
import SingleSelectDropdown from '../Reusable components/SingleSelect/SingleSelectDropdown';

const EvaluationForm = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  let contactid = location.state?.contactid || '';


  // const evaluationData = useSelector((state) => state.aquaaReducer.evaluationData);
  //const evaluationData = location.state?.evaluationData;
  const saveEvaluationData = useSelector((state) => state.aquaaReducer.saveEvaluationData);
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  const additionalReciepients = useSelector((state) => state.aquaaReducer.additionalReciepients)
  const aquaaValidateTicketNo = useSelector((state) => state.aquaaReducer.aquaaValidateTicketNo);
  const aquaaMarketGroup = useSelector((state) => state.aquaaReducer.aquaaMarketGroup);

  const [evaluationData, setEvaluationData] = useState([])


  useEffect(() => {
    setEvaluationData(saveEvaluationData);
  }, [saveEvaluationData])

  useEffect(() => {
    dispatch(getUserData());
  }, [dispatch])




  const [sections, setSections] = useState({});
  const [activeRows, setActiveRows] = useState({});
  const [responses, setResponses] = useState([]); // Track responses in state for re-render
  const [sectionComments, setSectionComments] = useState([]);
  const [selectedRecommendations, setSelectedRecommendations] = useState([]);
  const [selectedActionOwners, setSelectedActionOwners] = useState([]);
  const [validation, setValidation] = useState('');
  const [rebutModel, setRebutModel] = useState(false);
  const [dueDate, setDueDate] = useState(null);
  const [formData, setFormData] = useState({
    ticketNumber: '',
    voiceAnalytics: '',  // To store voice analytics value
    notifyManager: false,
    overallMapData: {
      'Best Interaction ?': false,
      'Focus Group ?': false,
      'Infra Issue ?': false,
      'New Hire ?': false
    },  // To store checkbox states for overall map data
  });
  const responsesRef = useRef([]); // This is kept for debugging purposes or persistence, but state will be primary

  useEffect(() => {
    if (contactid) {
      dispatch(getEvaluationFormData(contactid));
    }
  }, [dispatch, contactid]);

  // useEffect(() => {
  //   dispatch(getEvaluationFormData('E35C7824-C025-461D-BDAA-578BA403EAB9'))
  // }, [dispatch])





  const contactTypeForm = evaluationData?.[0]?.ContactTypeForm || [];
  const Overall = evaluationData?.[0]?.Overall || [];


  useEffect(() => {
    const groupedSections = contactTypeForm.reduce((acc, form) => {
      form.Section?.forEach((section) => {
        section.Questions?.forEach((question) => {
          const questionId = question.MappingID || `fallback-${question.MappingID}`;
          const row = {
            id: questionId,
            sectionName: section.Section_Name,
            parameterType: question.ParameterType,
            description: question.Question,
            ToolTip: question.ToolTip,
            questionscore: question.Score,
            ParameterType: question.ParameterType,
            assessments: question.Assessments,
            defaultassessment: question.DefaultValue || 1, // Ensure a default value of 1
            defaultId: question.DefaultId || null, // Ensure DefaultId is captured here
            comment: question.Comments,
            sectionComments: section.SectionComments
          };
          if (!acc[section.Section_Name]) {
            acc[section.Section_Name] = [];
          }
          acc[section.Section_Name].push(row);
        });
      });
      return acc;
    }, {});

    // Initialize responses with the default assessment for each question
    const initialResponses = [];
    const initialSectionComments = [];
    const initialActiveRows = {};
    Object.values(groupedSections).forEach((section) => {
      section.forEach((row) => {
        initialResponses.push({
          questionId: row.id, // Store questionId
          questionscore: row.questionscore,
          ParameterType: row.parameterType,
          sectionName: row.sectionName,
          assessmentId: row.defaultId, // Store the DefaultId as the initial assessmentId
          assessment: row.defaultassessment, // Set the default assessment here
          comment: row.comment, // If you want to track comments too
        });
        initialActiveRows[`${row.sectionName}-${row.id}`] = row.comment && row.comment.trim() !== '' ? true : false; // Set toggle to true if comment exists


      });
      // Initialize activeRows based on whether a comment exists

      // Initialize section comments with an empty string for each section
      initialSectionComments.push({
        name: section[0]?.sectionName || "Unknown Section", // Default to "Unknown Section" if name is missing
        comments: section[0]?.sectionComments, // Default to empty string
      });
    });

    // Set the sections and responses
    setSections(groupedSections);
    setResponses(initialResponses);  // Initialize responses with default assessments
    setSectionComments(initialSectionComments);
    setActiveRows(initialActiveRows); // Initialize section comments with empty values
  }, [contactTypeForm]);



  const handleToggle = (sectionName, rowId) => {
    setActiveRows((prevActiveRows) => ({
      ...prevActiveRows,
      [`${sectionName}-${rowId}`]: !prevActiveRows[`${sectionName}-${rowId}`],
    }));
  };

  const handleResponseChange = (sectionName, rowId, currentAssessment, key, value) => {
    // Debugging logs

    if (key === 'assessment') {
      // Handle updating the assessment value
      const selectedAssessment = sections[sectionName]
        .find(row => row.id === rowId) // Find the question in the section
        ?.assessments // Access the assessments for that question
        .find(a => a.Assessment === value); // Find the selected assessment by matching its text

      // Ensure DefaultId is available
      const selectedAssessmentId = selectedAssessment ? selectedAssessment.AssessmentID : null;

      // If the section is "Dispatch Defects" and "N/A" is selected, update all questions in the section to "N/A"
      if ((sectionName === "Dispatch Defects" || sectionName === "KM Defects") && value === "N/A") {
        // Update all questions in the section to "N/A"
        const updatedResponses = responses.map(resp => {
          if (resp.sectionName === sectionName) {
            return {
              ...resp,
              assessment: "N/A", // Set all assessments to "N/A"
              assessmentId: selectedAssessmentId, // Update DefaultId (assessmentId) accordingly
            };
          }
          return resp; // Keep the other responses unchanged
        });

        setResponses(updatedResponses); // Update state
        responsesRef.current = updatedResponses; // Update ref
      } else {
        // Handle individual question update if not part of the "Dispatch Defects" section or not "N/A"
        const updatedResponses = responses.map(resp => {
          if (resp.questionId === rowId && resp.sectionName === sectionName) {
            return {
              ...resp,
              assessment: value, // Update the assessment
              assessmentId: selectedAssessmentId, // Update DefaultId (assessmentId) accordingly
            };
          }
          return resp; // Keep the other responses unchanged
        });

        setResponses(updatedResponses); // Update state
        responsesRef.current = updatedResponses; // Update ref
      }
    } else if (key === 'comment') {
      // Handle updating the comment value
      const updatedResponses = responses.map(resp => {
        if (resp.questionId === rowId && resp.sectionName === sectionName) {
          return {
            ...resp,
            comment: value, // Update the comment field
          };
        }
        return resp; // Keep the other responses unchanged
      });

      setResponses(updatedResponses); // Update state with new comment
      responsesRef.current = updatedResponses; // Update ref
    }
  };



  const handleSectionCommentChange = (sectionName, value) => {
    setSectionComments(prevComments => {
      // Check if the section comment already exists in the array
      const sectionIndex = prevComments.findIndex(item => item.name === sectionName);

      if (sectionIndex >= 0) {
        // If exists, update the existing object
        const updatedComments = [...prevComments];
        updatedComments[sectionIndex] = { name: sectionName, comments: value };
        return updatedComments;
      } else {
        // If not exists, add a new object
        return [
          ...prevComments,
          { name: sectionName, comments: value },
        ];
      }
    });
  };

  useEffect(() => {
    // Populate formData with data from evaluationData (including checkboxes)
    if (evaluationData) {
      const initialCheckboxValues = {};
      evaluationData[0]?.Overall?.forEach(item => {
        if (item.iName !== "Voice Analytics") {
          initialCheckboxValues[item.iName] = item.iValue === "1"; // assuming '1' means checked
        }
      });

      setFormData(prevData => ({
        ...prevData,
        ticketNumber: evaluationData?.[0]?.AccountDetails?.[0]?.TicketNumber,
        voiceAnalytics: evaluationData?.[0]?.Overall?.find(item => item.iName === "Voice Analytics")?.iValue,
        overallMapData: initialCheckboxValues
      }));
    }
  }, [evaluationData]);


  const handleFormDataChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value, // Update specific key in formData
    }));
    if (key === 'notifyManager') {
      setSelectedRecipient((prevRecipients) => {
        if (value) {
          return prevRecipients.includes(evaluationData?.[0]?.['Nofity Manager']?.[0]?.NotifyManager) ? prevRecipients : [...prevRecipients, evaluationData?.[0]?.['Nofity Manager']?.[0]?.NotifyManager];
        } else {
          return prevRecipients.filter(item => item !== evaluationData?.[0]?.['Nofity Manager']?.[0]?.NotifyManager);
        }
      });
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);

    // Get day, month, year, hours, minutes, and seconds
    const day = String(d.getDate()).padStart(2, '0');  // Adds leading zero if day is less than 10
    const month = String(d.getMonth() + 1).padStart(2, '0');  // Months are 0-indexed
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    // Return the formatted date string
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };


  useEffect(() => {
    dispatch(getAquaaValidateTicketNo(formData.ticketNumber))
  }, [dispatch, formData.ticketNumber])


  console.log('aquaaValidateTicketNo', aquaaValidateTicketNo?.[0]?.duplicate)

  const dispatchHandler = (status) => {
    let QuestionDetails = responses.map(data => {
      return {
        "MappingID": data.questionId,
        "AssessmentID": data.assessmentId,
        "Comments": data.comment
      };
    });

    const invalidQuestionDetails = [];

    responses.forEach((resp) => {

      if (
        resp.questionId === null ||
        resp.questionId === undefined ||
        resp.questionId === "" ||
        String(resp.questionId).startsWith("fallback-") ||
        resp.assessmentId === null ||
        resp.assessmentId === undefined ||
        resp.assessmentId === ""
      ) {

        const sectionQuestions =
          sections[resp.sectionName] || [];

        const originalQuestion =
          sectionQuestions.find(
            q => q.id === resp.questionId
          );

        invalidQuestionDetails.push({
          response: resp,
          originalQuestion
        });
      }
    });

    if (invalidQuestionDetails.length > 0) {

      const debugPayload = {
        ContactID: evaluationData?.[0]?.AccountDetails?.[0]?.contactid,

        EvaluationID:
          evaluationData?.[0]?.AccountDetails?.[0]?.EvaluationID,

        Agent:
          evaluationData?.[0]?.AccountDetails?.[0]?.Agent,

        TicketNumber: formData.ticketNumber,

        InvalidQuestionDetails:
          JSON.stringify(invalidQuestionDetails),

        FullResponses:
          JSON.stringify(responses),

        FullQuestionDetails:
          JSON.stringify(QuestionDetails),

        Timestamp: new Date().toISOString(),

        Evaluator: userInfo?.email
      };

      dispatch(updateEFMissingDataStart({
        TestType: 'MISSING_ASSESSMENT',
        ...debugPayload
      }));

      // optional for now
      // return;
    }

    let SectionComments = Object.keys(sectionPercentages).map(section => {
      const scored = sectionwiseTotalMinusNotMet[section] || 0;
      const max = sectionScores[section] || 0;
      const percentage = sectionPercentages[section] || 0;

      const sectionCommentObj = sectionComments.find(comment => comment.name === section);
      const sectionComment = sectionCommentObj ? sectionCommentObj.comments : '';

      if (section === "Summary") {
        const summaryComment = sectionComments.find(comment => comment.name === "Summary")?.comments;
        return {
          "Section": section,
          "SecComments": summaryComment,
          "Fatal": feNotMetCount,
          "NonFatal": nfNotMetCount,
          "OverallScore": finalStatus
        };
      } else {
        return {
          "Section": section,
          "SecComments": sectionComment,
          "Scored": scored,
          "Max": max,
          "Percentage": percentage
        };
      }
    });

    if (!SectionComments.some(comment => comment.Section === "Summary")) {
      const summaryComment = sectionComments.find(comment => comment.name === "Summary")?.comments;
      SectionComments.push({
        "Section": "Summary",
        "SecComments": summaryComment,
        "Fatal": feNotMetCount,
        "NonFatal": nfNotMetCount,
        "OverallScore": finalStatus
      });
    }

    let DispObj = [
      {
        "Agent": evaluationData?.[0]?.AccountDetails?.[0]?.Agent,
        "TicketNumber": formData.ticketNumber,
        "ContactID": evaluationData?.[0]?.AccountDetails?.[0]?.contactid,
        "EvaluationDate": formatDate(Date()),
        "EvaluationID": evaluationData?.[0]?.AccountDetails?.[0]?.EvaluationID,
        "VoiceAnalytics": formData.voiceAnalytics,
        "FocusGroup": formData.overallMapData['Focus Group ?'],
        "NewHire": formData.overallMapData['New Hire ?'],
        "InfraIssue": formData.overallMapData['Infra Issue ?'],
        "BestInteraction": formData.overallMapData['Best Interaction ?'],
        "Status": status,
        "Recommendations": arrayToCommaSeparatedString(selectedRecommendations),
        "ActionOwners": arrayToCommaSeparatedString(selectedActionOwners),
        "Recipients": arrayToCommaSeparatedString(selectedRecipient),
        "NotifyManager": formData.notifyManager === true ? 1 : 0,
        "ActionDueDate": dueDate ? DateFormatter(dueDate) : null,
        "Details": QuestionDetails,
        "Sections": SectionComments,
        "Score": summaryPercentage,
        "Language": evaluationData?.[0]?.AccountDetails?.[0]?.Language,
        "MarketGroupID": selectedMarket?.ID
      }
    ];


    dispatch(updateEFMissingDataStart({
      TestType: 'FULL_SUBMISSION',
      ContactID: evaluationData?.[0]?.AccountDetails?.[0]?.contactid,
      EvaluationID:
        evaluationData?.[0]?.AccountDetails?.[0]?.EvaluationID,
      Agent:
        evaluationData?.[0]?.AccountDetails?.[0]?.Agent,
      TicketNumber: formData.ticketNumber,
      FullResponses: JSON.stringify(responses),
      FullQuestionDetails: JSON.stringify(QuestionDetails),
      DispObj: JSON.stringify(DispObj),
      Timestamp: new Date().toISOString(),
      Evaluator: userInfo?.email
    }));

    console.log('DispObj', {
      TestType: 'FULL_SUBMISSION',
      ContactID: evaluationData?.[0]?.AccountDetails?.[0]?.contactid,
      EvaluationID:
        evaluationData?.[0]?.AccountDetails?.[0]?.EvaluationID,
      Agent:
        evaluationData?.[0]?.AccountDetails?.[0]?.Agent,
      TicketNumber: formData.ticketNumber,
      FullResponses: JSON.stringify(responses),
      FullQuestionDetails: JSON.stringify(QuestionDetails),
      DispObj: JSON.stringify(DispObj),
      Timestamp: new Date().toISOString(),
      Evaluator: userInfo?.email
    });

    let savedTicketValidation = evaluationData?.[0]?.AccountDetails?.[0]?.TicketNumber === formData.ticketNumber

    if (!formData.ticketNumber || formData.ticketNumber.trim() === '') {
      setValidation('Please enter a valid ticket number.');
    }
    else if (!savedTicketValidation && aquaaValidateTicketNo?.[0]?.duplicate === 'True') {
      setValidation('This ticket is already evaluated');
    }
    else if (
      finalStatus === "Fail" &&
      (
        selectedRecommendations.length === 0 ||
        selectedActionOwners.length === 0 ||
        (selectedRecommendations.length > 0 && !dueDate)
      )
    ) {
      if (!dueDate && selectedRecommendations.length > 0) {
        setValidation("Target Closure Date is mandatory when Overall Score is Fail.");
      } else {
        setValidation("Recommendations and Action Owners are mandatory when Overall Score is Fail.");
      }
    }
    else {
      setValidation('');
      dispatch(updateEvaluationFormDataStart(DispObj));
      history.push(
        evaluationData?.[0]?.AccountDetails?.[0]?.source === 'ASD'
          ? '/aquaa'
          : '/aquaanonasd'
      );
    }
  };























  const { sectionScores, sectionwiseTotalMinusNotMet, sectionPercentages, summaryPercentage, nfNotMetCount, feNotMetCount, finalStatus } =
    processScores(responses, evaluationData?.[0]?.AccountDetails?.[0]?.CalMethod, evaluationData?.[0]?.AccountDetails?.[0]?.ContactTypeForm, evaluationData?.[0]?.AccountDetails?.[0]?.TicketCalc);





  const recommendationOptions = evaluationData?.[0]?.Recommendations.map(item => item.Recommendations);
  const actionOwnerOptions = evaluationData?.[0]?.['Action Owner'].map(item => item["Action Owner"]);

  const handleRecommendationsChange = (newSelection) => {
    setSelectedRecommendations(newSelection);
  };

  const handleActionOwnersChange = (newSelection) => {
    setSelectedActionOwners(newSelection);
  };



  useEffect(() => {
    dispatch(getRolesTabUsers(''));
  }, [dispatch])

  const [selectedRecipient, setSelectedRecipient] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  // Debounced search function
  const debouncedSearch = debounce((query) => {
    dispatch(getAdditionalReciepientsData(query));  // Make the API call with search query
  }, 500); // 500ms debounce time, adjust as needed

  const handleRecipientChange = (newSelection) => {
    const filteredSelection = newSelection.filter(val => val != null);
    setSelectedRecipient(filteredSelection);
  };
  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    debouncedSearch(query);
  };


  const convertToStringArray = (data) => {
    return data.map((item) => item.email);
  };

  const arrayToCommaSeparatedString = (array) => {
    return array.map(value => `${value}`).join(', ');
  };

  const splitStringToArray = (str) => {
    return str.split(',').map(item => item.trim());
  };
  useEffect(() => {
    if (evaluationData?.[0]?.RecommendationsSaved?.[0]?.Recommendations) {
      setSelectedRecommendations(splitStringToArray(evaluationData?.[0]?.RecommendationsSaved?.[0]?.Recommendations))
    }
    if (evaluationData?.[0]?.['Action Owner Saved']?.[0]?.['Action Owner']) {
      setSelectedActionOwners(splitStringToArray(evaluationData?.[0]?.['Action Owner Saved']?.[0]?.['Action Owner']))
    }
    if (evaluationData?.[0]?.['Additional Recipient Saved']?.[0]?.['Additional Recipient']) {
      setSelectedRecipient(splitStringToArray(evaluationData?.[0]?.['Additional Recipient Saved']?.[0]?.['Additional Recipient']))
    }
  }, [evaluationData])

  const View = evaluationData?.[0]?.AccountDetails?.[0]?.View






  const initialState = {
    evaluationData: saveEvaluationData,
    formData: {
      ticketNumber: '',
      voiceAnalytics: '',
      notifyManager: false,
      overallMapData: {
        'Best Interaction ?': false,
        'Focus Group ?': false,
        'Infra Issue ?': false,
        'New Hire ?': false
      },
    },
    sections: {},
    activeRows: {},
    responses: [],
    sectionComments: [],
  };

  // Reset Function
  const resetFormData = () => {
    setEvaluationData(saveEvaluationData);
    setFormData({
      ticketNumber: saveEvaluationData?.[0]?.AccountDetails?.[0]?.TicketNumber || '',
      voiceAnalytics: saveEvaluationData?.[0]?.Overall?.find(item => item.iName === "Voice Analytics")?.iValue || '',
      overallMapData: initialState.formData.overallMapData,
    });

    const groupedSections = saveEvaluationData?.[0]?.ContactTypeForm?.reduce((acc, form) => {
      form.Section?.forEach((section) => {
        section.Questions?.forEach((question) => {
          const questionId = question.MappingID || `fallback-${question.MappingID}`;
          const row = {
            id: questionId,
            sectionName: section.Section_Name,
            parameterType: question.ParameterType,
            description: question.Question,
            ToolTip: question.ToolTip,
            questionscore: question.Score,
            ParameterType: question.ParameterType,
            assessments: question.Assessments,
            defaultassessment: question.DefaultValue || 1,
            defaultId: question.DefaultId || null,
            comment: question.Comments,
            sectionComments: section.SectionComments,
          };
          if (!acc[section.Section_Name]) {
            acc[section.Section_Name] = [];
          }
          acc[section.Section_Name].push(row);
        });
      });
      return acc;
    }, {});

    // Initialize responses with default assessment for each question
    const initialResponses = [];
    const initialSectionComments = [];
    const initialActiveRows = {};

    Object.values(groupedSections).forEach((section) => {
      section.forEach((row) => {
        initialResponses.push({
          questionId: row.id,
          questionscore: row.questionscore,
          ParameterType: row.parameterType,
          sectionName: row.sectionName,
          assessmentId: row.defaultId,
          assessment: row.defaultassessment,
          comment: row.comment,
        });
        initialActiveRows[`${row.sectionName}-${row.id}`] = row.comment && row.comment.trim() !== '' ? true : false;
      });

      initialSectionComments.push({
        name: section[0]?.sectionName || "Unknown Section",
        comments: section[0]?.sectionComments || '',
      });
    });

    // Set initial state values
    setSections(groupedSections);
    setResponses(initialResponses);
    setSectionComments(initialSectionComments);
    setActiveRows(initialActiveRows);
    setSelectedRecommendations([]);
    setSelectedActionOwners([]);
    setSelectedRecipient([])
  };

  const [comment, setComment] = useState('');

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const RebutHandler = () => {
    dispatch(updateAquaaAcknowledgementDataStart([{ "EvaluationsID": evaluationData?.[0]?.AccountDetails?.[0]?.EvaluationID, "Acknowledge_Rebut": "Rebut", "Comments": comment }]));
    setRebutModel(false);
    history.push('/aquaaagentsevaluations');
  }

  const submittedBreadcrumb = evaluationData?.[0]?.AccountDetails?.[0]?.Agent === userInfo?.email
  useEffect(() => {
    if (finalStatus !== "Fail") {
      setDueDate(null);
    }
  }, [finalStatus]);
  useEffect(() => {
  const accountId =
    evaluationData?.[0]?.AccountDetails?.[0]?.AccountID;

  if (accountId) {
    dispatch(getAquaaMarketGroupData(accountId));
  }
}, [dispatch, evaluationData]);

  const isMarketGroupVisible = aquaaMarketGroup?.[0]?.ShowYesNo?.[0]?.Visible === 1;
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [marketSearchQuery, setMarketSearchQuery] = useState('');


  console.log('selectedMarket', selectedMarket?.ID)

  return (
    <Fragment>
      <div style={{ width: 1150, margin: 'auto' }}>
        <section className='Display_static'>
          <div style={{ marginLeft: '-10px' }}>
            {View === 'True' && submittedBreadcrumb === true ? <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={true}
              label3='AQuAA Agent Evaluations' value3={() => history.push('/aquaaagentsevaluations')} isActive4={false} label4='Evaluation Form' /> :
              <AdminBreadcrumb value1={() => history.push('/applications')} label1='Applications' isActive2={true} value2={() => history.push('/aquaaapplications')} label2='AQuAA' isActive3={true} value3={() => history.push(evaluationData?.[0]?.AccountDetails?.[0]?.source === 'ASD' ? '/aquaa' : '/aquaanonasd')} label3={evaluationData?.[0]?.AccountDetails?.[0]?.source === 'ASD' ? 'AQuAA - ASD' : 'AQuAA - Non ASD'} isActive4={false}
                label4='Evaluation Form' />
            }
          </div>
          <main style={{ display: 'flex', gap: '20px', marginTop: 20 }}>
            {/* Inputs for Ticket Number, Title, Agent Email, etc. */}
            <div className='TicketNoInput'>
              <div><label>Ticket Number</label></div>
              {View === 'True' ? evaluationData?.[0]?.AccountDetails?.[0]?.TicketNumber : <input
                type="text"
                placeholder="Example: 0123456789"
                value={formData.ticketNumber}
                onChange={(e) => handleFormDataChange('ticketNumber', e.target.value)}  // Bind to formData.ticketNumber
              />}
            </div>
            {evaluationData?.[0]?.AccountDetails?.[0]?.source === 'ASD' && <div>
              <label>Contact id</label>
              <div> {evaluationData?.[0]?.AccountDetails?.[0]?.URL ? <a href={evaluationData?.[0]?.AccountDetails?.[0]?.URL} target="_blank" rel="noopener noreferrer" className='static_info'>
                {evaluationData?.[0]?.AccountDetails?.[0]?.contactid}
              </a> :
                <div className='static_info'>{evaluationData?.[0]?.AccountDetails?.[0]?.contactid}
                </div>}</div></div>}
            <div >
              <label>Agent Email</label>
              <div className='static_info'>{evaluationData?.[0]?.AccountDetails?.[0]?.Agent}</div>
            </div>
            <div >
              <label>Account</label>
              <div className='static_info'>{evaluationData?.[0]?.AccountDetails?.[0]?.Account}</div>
            </div>
            <div >
              <label>Evaluation Form</label>
              <div className='static_info'>{evaluationData?.[0]?.AccountDetails?.[0]?.ContactTypeForm}</div>
            </div>
            <div >
              <label>Evaluation Date</label>
              <div className='static_info'>{evaluationData?.[0]?.AccountDetails?.[0]?.Status === 'Submitted' ? formatDate(evaluationData?.[0]?.AccountDetails?.[0]?.EvaluationDate) : formatDate(Date())}</div>
            </div>
            {View === 'False' && <main>
              <img src={Reset_Icon} alt='' onClick={resetFormData} style={{ cursor: 'pointer', width: '30px' }} />
            </main>}
          </main>


          {validation && <div className='validation-error'>{validation}</div>}
          <main className='ScoresTab'>
            {evaluationData?.[0]?.GroupSections && evaluationData?.[0]?.GroupSections.map((section) => {
              const sectionKey = section.Section_Name;
              return (
                <main className='scoresSection' key={sectionKey}>
                  <div className='displayscores'>
                    <div className='Section_Name'>{section.Section_Name}</div>
                    <div className='scoredMaxpaints'>
                      <div>Scored</div>
                      {sectionwiseTotalMinusNotMet?.[sectionKey]}
                    </div>
                    <div className='scoredMaxpaints'>
                      <div>Max</div>
                      {sectionScores?.[sectionKey]}
                    </div>
                  </div>
                  <div style={{ paddingTop: '8%' }}>
                    <div className='score_in_Percentage'>
                      {sectionPercentages?.[sectionKey]}
                    </div>
                  </div>
                </main>
              );
            })}

            {/* Summary Section */}
            <main className='scoresSection'>
              <div className='displayscores'>
                <div className='Section_Name'>Summary</div>
                <div className='scoredMaxpaints'>
                  <div>Fatal</div>
                  {feNotMetCount}
                </div>
                <div className='scoredMaxpaints'>
                  <div>Non Fatal</div>
                  {nfNotMetCount}
                </div>
                <div className='scoredMaxpaints'>
                  <div>Overall Score</div>
                  {finalStatus}
                </div>
              </div>
              <div style={{ paddingTop: '5%' }}>
                <div className='score_in_Percentage'>{summaryPercentage}</div>
              </div>
            </main>
          </main>
        </section>
        <main className='Display_scroll'>
          {Object.keys(sections).map((sectionName) => (
            <div key={sectionName} style={{ marginBottom: '30px' }}>
              <div className='Section_header'>{sectionName}</div>
              {sectionName === 'Summary' ? (
                <>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Tracking Questions</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {sections[sectionName].map((row) => (
                        <tr key={row.id}>
                          <td title={row.ToolTip}>{row.description}</td>
                          <td>
                            {View === 'True' ? <span style={{ marginRight: '20px' }}> {row.defaultassessment} </span> : <select
                              value={responses.find(resp => resp.questionId === row.id && resp.sectionName === sectionName)?.assessment || row.defaultassessment}
                              onChange={(e) => handleResponseChange(sectionName, row.id, row.assessments[0]?.AssessmentId, 'assessment', e.target.value)}
                            >
                              {row.assessments?.length > 0 ? (
                                row.assessments.map((assessment) => (
                                  <option key={assessment.AssessmentId} value={assessment.Assessment}>{assessment.Assessment}</option>
                                ))
                              ) : (
                                <option value="N/A">N/A</option>
                              )}
                            </select>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="OvarallComments">
                    <div>
                      {Overall.map((data) => (
                        <div className='Iname_box'>
                          <span style={{ width: 150 }}>{data.iName}</span>
                          {data.iName === 'Voice Analytics' ? (
                            <span>
                              <input
                                type='number'
                                value={formData.voiceAnalytics || data.iName}
                                onChange={(e) => handleFormDataChange('voiceAnalytics', e.target.value)}
                              />
                            </span>
                          ) : (
                            <span>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={formData.overallMapData[data.iName] || false}
                                  onChange={() => handleFormDataChange('overallMapData', { ...formData.overallMapData, [data.iName]: !formData.overallMapData[data.iName] })}
                                />
                                <span className="slider"></span>
                              </label>
                            </span>
                          )}
                        </div>
                      ))}
                      {isMarketGroupVisible &&<>
                       
<main className='multiSelectLabel' style={{marginBottom:'10px',marginTop:'10px'}}>Market</main>
                        <SingleSelectDropdown
                                options={aquaaMarketGroup?.[0]?.MarketGroup || []}
                      value={selectedMarket}
                      onChange={(obj) => setSelectedMarket(obj)}
                      returnType="object"
                      displayField="MarketGroup"
                       width={240}
  height={28}
                      placeholder="Select Market"
                       searchQuery={marketSearchQuery}
  onSearchQueryChange={(e) => setMarketSearchQuery(e.target.value)}
/>
   </>   
                        
                                  }
                    </div>
                    <div >
                      <textarea style={{ width: '100%' }}
                        type="text"
                        placeholder="Overall comments"
                        value={sectionComments.find(item => item.name === sectionName)?.comments || ''}
                        onChange={(e) => handleSectionCommentChange(sectionName, e.target.value)}
                      />
                    </div>
                    <div>
                      <main className='multiSelectLabel'>Recommendations</main>
                      <MultipleSelectChip
                        options={recommendationOptions}
                        label="Recommendations"
                        value={selectedRecommendations}
                        onChange={handleRecommendationsChange}
                        searchEnabled={false}
                        placeholder="Search Recommendations"
                      />
                      {finalStatus === "Fail" && selectedRecommendations.length > 0 && (
                        <div style={{ marginTop: 15 }}>
                          <main className="multiSelectLabel">
                            Action Due Date *
                          </main>

                          <KeyboardDatePicker
                            autoOk
                            variant="inline"
                            inputVariant="outlined"
                            format="YYYY-MM-DD"
                            margin="normal"
                            label="Select Date"
                            value={dueDate}
                            onChange={(date) => setDueDate(date)}
                            minDate={new Date()}
                            disablePast
                            fullWidth
                            error={!dueDate}
                            helperText={!dueDate ? "Action Due Date is required" : ""}
                          />
                        </div>
                      )}
                      <main className='multiSelectLabel'>Action Owner</main>
                      <MultipleSelectChip
                        options={actionOwnerOptions}
                        label="Action Owners"
                        value={selectedActionOwners}
                        onChange={handleActionOwnersChange}
                        searchEnabled={false}
                        placeholder="Search Action Owners"
                      />
                      <main className='multiSelectLabel'>Additional Recipient</main>
                      <MultipleSelectChip
                        options={convertToStringArray(additionalReciepients)}
                        label="Recipient"
                        value={selectedRecipient}
                        onChange={handleRecipientChange}
                        searchEnabled={true}
                        placeholder="Search Recipient"
                        searchQuery={searchQuery}  // Pass search query as prop
                        onSearchQueryChange={handleSearchChange}  // Pass handler to update search query
                      />
                      <div style={{ display: 'flex', gap: '40px' }}>
                        <main className='multiSelectLabel'>Notify Manager</main>

                        <label className="switch">
                          <input
                            type="checkbox"
                            id="notifyManager"
                            checked={formData.notifyManager || false}
                            onChange={(e) => handleFormDataChange('notifyManager', e.target.checked)}
                            role="switch"
                            aria-checked={formData.notifyManager || false}
                            aria-label="Notify manager"
                          />
                          <span className="slider" aria-hidden="true"></span>
                        </label>
                      </div>
                      <div>{evaluationData?.[0]?.['Nofity Manager']?.[0]?.NotifyManager}</div>

                    </div>

                  </div>
                </>
              ) : (
                <>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Parameter Type</th>
                        <th>Description</th>
                        <th>Assessment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sections[sectionName].map((row) => {

                        const response = responses.find(resp => resp.questionId === row.id && resp.sectionName === sectionName);
                        const commentExists = response?.comment;
                        return (
                          <tr key={row.id}>
                            <td style={{ color: row.parameterType === 'FE' ? 'red' : 'black' }}>{row.parameterType}</td>
                            <td title={row.ToolTip}>{row.description}</td>
                            <td>
                              {View === 'True' ? <span style={{ marginRight: '20px' }}> {row.defaultassessment} </span> : <select
                                value={responses.find(resp => resp.questionId === row.id && resp.sectionName === sectionName)?.assessment || row.defaultassessment}
                                onChange={(e) => handleResponseChange(sectionName, row.id, row.assessments[0]?.AssessmentId, 'assessment', e.target.value)}
                              >
                                {row.assessments?.length > 0 ? (
                                  row.assessments.map((assessment) => (
                                    <option key={assessment.AssessmentId} value={assessment.Assessment}>{assessment.Assessment}</option>
                                  ))
                                ) : (
                                  <option value="N/A">N/A</option>
                                )}
                              </select>}
                              <label className="customToggleWrapper">
                                <input
                                  type="checkbox"
                                  className="customToggleInput"
                                  checked={!!activeRows[`${sectionName}-${row.id}`] || commentExists}
                                  onChange={() => handleToggle(sectionName, row.id)}
                                />
                                <span className="customToggleSlider"></span>
                              </label>
                              {activeRows[`${sectionName}-${row.id}`] || commentExists ? (
                                <input
                                  type="text"
                                  value={commentExists || ''}  // Make sure this is connected to the responses state
                                  onChange={(e) => handleResponseChange(sectionName, row.id, 'assessment', 'comment', e.target.value)}  // Ensure correct key for comment
                                  placeholder="Enter comment"
                                />
                              ) : null}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  <div className="SectionComments">
                    <input
                      type="text"
                      placeholder="Enter section-level comments"
                      value={sectionComments.find(item => item.name === sectionName)?.comments || ''}
                      onChange={(e) => handleSectionCommentChange(sectionName, e.target.value)}
                    />
                  </div>
                </>
              )}
            </div>
          ))}
        </main>
        {View === 'True' ?
          (evaluationData?.[0]?.AccountDetails?.[0]?.Ack === 'True' ? <section style={{ display: 'flex', justifyContent: 'center' }}> <main>
            <button className='btn_Acknowledge' onClick={() => { dispatch(updateAquaaAcknowledgementDataStart([{ "EvaluationsID": evaluationData?.[0]?.AccountDetails?.[0]?.EvaluationID, "Acknowledge_Rebut": "Acknowledge", "Comments": "" }])); history.push('/aquaaagentsevaluations') }}>Acknowledge</button></main>
            <main>
              <button className='btn_adduser' onClick={() => setRebutModel(true)}>Rebut</button></main></section> : '')
          :
          <section style={{ display: 'flex' }}>
            {evaluationData?.[0]?.AccountDetails?.[0]?.Status === 'New' &&
              <main>
                <img src={Save_Image} onClick={() => dispatchHandler('Saved')} alt='' height='50px' width='50px' style={{ cursor: 'pointer' }} />
              </main>
            }
            <main style={{ marginLeft: '30%', marginRight: '40%' }}>
              <button className='btn_adduser' onClick={() => dispatchHandler('Submitted')}>SUBMIT</button></main>



          </section>}


        {rebutModel &&
          <AssignedAccountsTblPopUp isOpen={rebutModel} setShowModal={setRebutModel}>
            <div >
              <textarea
                name='comment'
                value={comment}
                onChange={handleCommentChange}
                placeholder=" Enter your comment here..."
                rows="5"  // Adjust the number of rows for initial height
                cols="50" // Adjust the number of columns for initial width
              />
            </div>
            <main style={{ display: 'flex', justifyContent: 'center' }}> <div className='btn_adduser' onClick={() => RebutHandler()}>Save</div></main>
          </AssignedAccountsTblPopUp>
        }
      </div>
    </Fragment>
  );
};

export default EvaluationForm;
